import { Link } from "react-router-dom";
import { Compass, Mail } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-white border-t border-brand-border mt-24"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center gap-2">
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-brand-sage text-white">
                <Compass className="h-4 w-4" strokeWidth={1.75} />
              </span>
              <span className="font-display text-lg font-semibold text-brand-ink">
                One Step Ahead Parents
              </span>
            </Link>
            <p className="mt-4 text-sm text-brand-inkMuted max-w-sm leading-relaxed">
              Practical systems and tools that help elementary school parents stay
              organized, reduce stress, and avoid missing the important stuff.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.2em] font-bold text-brand-sage">
              Explore
            </p>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/resources" className="text-brand-inkSoft hover:text-brand-ink transition-colors">Resources</Link></li>
              <li><Link to="/products" className="text-brand-inkSoft hover:text-brand-ink transition-colors">Products</Link></li>
              <li><Link to="/blog" className="text-brand-inkSoft hover:text-brand-ink transition-colors">Blog</Link></li>
              <li><Link to="/about" className="text-brand-inkSoft hover:text-brand-ink transition-colors">About Lisa</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs uppercase tracking-[0.2em] font-bold text-brand-sage">
              Stay in the loop
            </p>
            <p className="mt-4 text-sm text-brand-inkMuted">
              Weekly school organization strategies straight to your inbox.
            </p>
            <Link
              to="/resources#subscribe"
              data-testid="footer-subscribe-cta"
              className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-brand-ink hover:text-brand-sageDark transition-colors"
            >
              <Mail className="h-4 w-4" strokeWidth={1.75} />
              Subscribe to the newsletter
            </Link>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-brand-border flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-brand-inkMuted">
            © {year} One Step Ahead Parents. Made for busy parents.
          </p>
          <p className="text-xs text-brand-inkMuted">
            Built with care · Helping families stay one step ahead
          </p>
        </div>
      </div>
    </footer>
  );
}
